import { useInstantSearch, useSortBy, UseSortByProps } from 'react-instantsearch';
import { SORT_TOKEN_RELEVANCE, virtualIndex } from '@/constants/search.constants';

/**
 * `useSortBy`, minus the relevance option when there is no search term — without a query every
 * hit scores the same, so "relevance" is just an arbitrary order. Kept while it is the active
 * sort, so the dropdown never shows a selection that is not in its list.
 */
const useSortOptions = (props: UseSortByProps) => {
  const sortBy = useSortBy(props);
  const { indexUiState } = useInstantSearch();
  const relevance = virtualIndex(SORT_TOKEN_RELEVANCE);
  const hasQuery = Boolean(indexUiState.query?.trim());

  const options = sortBy.options.filter(
    o => hasQuery || o.value !== relevance || o.value === sortBy.currentRefinement
  );
  return { ...sortBy, options };
};

export default useSortOptions;
